// import Supabase
import { createClient } from '@supabase/supabase-js';

// Setup 
const config = {
    url: "https://uoiqgwynobahlcojpuqc.supabase.co",
    key: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVvaXFnd3lub2JhaGxjb2pwdXFjIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NTUyNzAzOTEsImV4cCI6MTk3MDg0NjM5MX0.-vkWZeSnoUMtaPg1NMG4qGD9oDl8KvaXz4UeKEFI9CY"
}

    // url: "https://pjkbbmrhhxqndsutimbl.supabase.co",
    // key: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTYxNzExNTA5MSwiZXhwIjoxOTMyNjkxMDkxfQ.Ii8olqXXJ_-jNkBe9-oTRVmXDJ_7a-ntqbUUMEqrgIk"

    // Create a single supabase client for interacting with your database 
const supabase = createClient(config.url, config.key);

// Export supabase
export default supabase;

// Export config
export { config };